/* @flow */
export const SCREEN_SIZE: Object = {
  small: '640px',
  medium: '750px',
  medium_2: '770px',
  big: '1024px'
};
